<div class="srm-overlay" (click)="onCancel()">
  <div class="srm-modal srm-modal--wide" (click)="$event.stopPropagation()">
    <header class="srm-head">
      <div class="srm-head-titleblock">
        <h2 class="srm-title">Access Groups</h2>
        <p class="srm-sub">Reusable named bundles of events and plans</p>
      </div>
      <button type="button" class="srm-close" (click)="onCancel()" aria-label="Close">×</button>
    </header>

    <div class="srm-body agm-body">
      <div class="agm-error" *ngIf="error">{{ error }}</div>

      <div class="agm-panes">
        <!-- Left: the list of groups -->
        <aside class="agm-groups">
          <div class="srm-toolbar agm-groups-head">
            <span class="srm-label">Groups</span>
            <button type="button" class="srm-link-btn" (click)="addGroup()">+ New group</button>
          </div>

          <div class="agm-group-list">
            <div class="agm-group-row"
                 *ngFor="let group of groups; trackBy: trackGroup"
                 [class.agm-group-row--active]="group.id === activeGroupId"
                 (click)="selectGroup(group)">
              <div class="agm-group-name-wrap">
                <input type="text" class="srm-input agm-group-name"
                       [class.agm-group-name--error]="group.nameError"
                       placeholder="Group name"
                       [(ngModel)]="group.name"
                       (click)="$event.stopPropagation()" />
                <span class="agm-group-count">{{ group.items.length }} item(s)</span>
              </div>
              <button type="button" class="srm-chip-x agm-group-remove"
                      (click)="$event.stopPropagation(); removeGroup(group)"
                      aria-label="Remove group">×</button>
            </div>
            <div class="srm-empty" *ngIf="!groups.length">
              No access groups yet. Create one to get started.
            </div>
          </div>
        </aside>

        <!-- Right: events/plans for the active group -->
        <section class="agm-items">
          <div class="srm-label">Events &amp; plans in this group</div>

          <div class="srm-list" *ngIf="activeGroup; else noActive">
            <div class="srm-list-scroll">
              <ng-container *ngFor="let ev of events; trackBy: trackEvent">
                <div class="srm-list-row"
                     [class.srm-list-row--selected]="isEventInActive(ev)">
                  <button type="button" class="srm-row-expand"
                          *ngIf="ev.plans.length"
                          (click)="toggleExpand(ev)">{{ isExpanded(ev) ? '▾' : '▸' }}</button>
                  <span class="srm-row-expand" *ngIf="!ev.plans.length"></span>
                  <input type="checkbox" [checked]="isEventInActive(ev)" (change)="toggleEvent(ev)" />
                  <span class="srm-row-name" (click)="toggleEvent(ev)">{{ ev.eventName }}</span>
                  <span class="srm-row-meta" *ngIf="ev.description">{{ ev.description }}</span>
                </div>
                <ng-container *ngIf="isExpanded(ev)">
                  <div class="srm-list-row srm-list-row--nested"
                       *ngFor="let plan of ev.plans; trackBy: trackPlan"
                       [class.srm-list-row--selected]="isPlanInActive(ev, plan)"
                       (click)="togglePlan(ev, plan)">
                    <input type="checkbox" [checked]="isPlanInActive(ev, plan)"
                           (click)="$event.stopPropagation()" (change)="togglePlan(ev, plan)" />
                    <span class="srm-row-name">{{ plan }}</span>
                  </div>
                </ng-container>
              </ng-container>
              <div class="srm-empty" *ngIf="!events.length">No events available.</div>
            </div>
          </div>

          <ng-template #noActive>
            <div class="srm-empty">Select or create a group to add events.</div>
          </ng-template>
        </section>
      </div>
    </div>

    <footer class="srm-foot">
      <button type="button" class="srm-btn srm-btn-cancel" (click)="onCancel()" [disabled]="saving">Cancel</button>
      <button type="button" class="srm-btn srm-btn-save" (click)="onSave()" [disabled]="saving">
        {{ saving ? 'Saving…' : 'Save groups' }}
      </button>
    </footer>
  </div>
</div>
